import React from 'react';

class DateWithinFields extends React.Component {
  constructor(props) {
    super(props);
    this.handleUnitNumberInput = this.handleUnitNumberInput.bind(this);
    this.handleUnitSelection = this.handleUnitSelection.bind(this);
  }

  handleUnitNumberInput(e) {
    this.props.onChange({ unitNumber: e.target.value });
  }

  handleUnitSelection(e) {
    this.props.onChange({ unit: e.target.value });
  }

  render() {
    const { unitNumber, units } = this.props;

    return (
      <span>
        <input
          className="Rule-input Rule-dateInput NewInput NewInput--white"
          onChange={this.handleUnitNumberInput}
          min="0"
          max="999"
          value={unitNumber || ''}
          type="number"
          style={{ width: this.determineWidth }}
          aria-label={t('smart_groups.create_modal.timeframe_placeholder')}
        />
        <select
          className="Rule-select"
          onChange={this.handleUnitSelection}
          value={this.props.unit || ''}
          aria-label={t('smart_groups.create_modal.timeframe_placeholder')}
        >
          <option disabled value="">
            {t('smart_groups.create_modal.timeframe_placeholder')}
          </option>
          {Object.keys(units).map(unit => (
            <option key={unit} value={units[unit]}>
              {units[unit]}
              (s)
            </option>
          ))}
        </select>
      </span>
    );
  }
}

export default DateWithinFields;
